<template>
  <div class="user-wrapper">
    <div class="content-box">
      <!--      暂时隐藏问号和notice的icon-->
      <!--      <a href="https://pro.loacg.com/docs/getting-started" target="_blank">-->
      <!--        <span class="action">-->
      <a-tooltip title="点击下载系统操作手册">
        <a href="http://www.jnsxyl.com:59001/doc.zip">
          <a-icon type="file-zip" /> 操作手册
        </a>
      </a-tooltip>
      <!--        </span>-->
      <!--      </a>-->
      <!--      <notice-icon class="action"/>-->
      <a-dropdown>
        <span class="action ant-dropdown-link user-dropdown-menu">
          <!--          <a-avatar class="avatar" size="small" id="avatar"/>-->
          <span>{{ nickname() }}</span>
        </span>
        <a-menu slot="overlay" class="user-dropdown-menu-wrapper">
          <a-menu-item key="1">
            <router-link :to="{ name: 'settings' }">
              <a-icon type="setting"/>
              <span>账户设置</span>
            </router-link>
          </a-menu-item>
          <a-menu-divider/>
          <a-menu-item key="3">
            <a href="javascript:;" @click="handleLogout">
              <a-icon type="logout"/>
              <span>退出登录</span>
            </a>
          </a-menu-item>
        </a-menu>
      </a-dropdown>
    </div>
  </div>
</template>

<script>
import NoticeIcon from '@/components/NoticeIcon'
import { mapActions, mapGetters } from 'vuex'
// import { handleImg } from '@/utils/util'

export default {
  name: 'UserMenu',
  components: {
    NoticeIcon
  },
  methods: {
    ...mapActions(['Logout']),
    ...mapGetters(['nickname', 'avatar']),
    handleLogout () {
      const that = this

      this.$confirm({
        title: '提示',
        content: '真的要注销登录吗 ?',
        onOk () {
          return that.Logout({}).then(() => {
            window.location.reload()
          }).catch(err => {
            that.$message.error({
              title: '错误',
              description: err.message
            })
          })
        },
        onCancel () {
        }
      })
    }
  },
  created () {
    // handleImg(this.avatar(), 'avatar')
  }
}
</script>
